import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Справочник содержит информацию о грузовых вагонах.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " Изначально в справочник добавлена информация о вагонах универсального назначения из документа «Технические условия размещения и крепления грузов в вагонах и контейнерах» (утв. МПС РФ 27.05.2003 N ЦМ-943) ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Наименование – наименование грузового вагона"),
  /*#__PURE__*/_createElementVNode("li", null, "Длина, Ширина, Высота (мм) – размеры грузового вагона"),
  /*#__PURE__*/_createElementVNode("li", null, "Вес порожнего вагона (кг) – вес порожнего вагона"),
  /*#__PURE__*/_createElementVNode("li", null, " Грузоподъемность (кг) – максимальная грузоподъемность грузового вагона "),
  /*#__PURE__*/_createElementVNode("li", null, " Ширина, высота дверного проема (мм) – задает размеры дверных проемов (считается, что они расположены в центре вагона) "),
  /*#__PURE__*/_createElementVNode("li", null, " Толщина дверного проема (мм) – задает пространство внутри вагона занимаемого дверным проемом "),
  /*#__PURE__*/_createElementVNode("li", null, " Высота ЦТ порожнего вагона (мм) – высота центра тяжести порожнего вагона над УГР (Уровень головки рельса) "),
  /*#__PURE__*/_createElementVNode("li", null, " Высота уровня настила пола (мм) – высота уровня настила пола над УГР "),
  /*#__PURE__*/_createElementVNode("li", null, " Допускаемое смещение общего груза ЦТ груза в транспорте – параметры для задания допустимых продольных и поперечных смещений центра тяжести грузов в вагоне (см. справочник Допускаемое смещение общего ЦТ груза в транспорте) "),
  /*#__PURE__*/_createElementVNode("li", null, " Отступы – параметры для задания отступов от стен контейнера (см. справочник Отступы) ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Грузовые вагоны",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}